import { useDispatch, useSelector } from 'react-redux';
import { setAppLanguage } from '../../store/appSlice';
import { saveLanguage } from '../../helpers/language-switcher';

const LanguageToggleBtn = () => {
    const dispatch = useDispatch();
    const hrMobileLanguage = useSelector((state) => state.app.slsHrMobileLanguage);

    const toggleLanguage = () => {
        const newLang = hrMobileLanguage === 'th' ? 'en' : 'th';

        saveLanguage(newLang);
        dispatch(setAppLanguage(newLang));
    };

    // แสดงธงของภาษาที่จะเปลี่ยนไป (ถ้าภาษาปัจจุบันเป็น TH ให้แสดงธง EN)
    const flagImage = hrMobileLanguage === 'th' ? '/images/en.svg' : '/images/th.svg';
    const altText = hrMobileLanguage === 'th' ? 'Switch to English' : 'เปลี่ยนเป็นภาษาไทย';

    return (
        <button
            onClick={toggleLanguage}
            style={{
                border: 'none',
                borderRadius: '4px',
                background: 'transparent',
                padding: '4px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.15s ease',
                width: '32px',
                height: '32px',
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.background = 'rgba(0, 0, 0, 0.05)';
                e.currentTarget.style.transform = 'scale(1.05)';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.transform = 'scale(1)';
            }}
            title={altText}
        >
            <img
                src={flagImage}
                alt={altText}
                style={{
                    width: '24px',
                    height: '24px',
                    objectFit: 'contain',
                    display: 'block',
                    borderRadius: '2px',
                    filter: 'grayscale(0.3) saturate(0.7) brightness(0.95)',
                    transition: 'filter 0.15s ease',
                }}
            />
        </button>
    );
};

export default LanguageToggleBtn;
